import { render, staticRenderFns } from "./AgeLimits.vue?vue&type=template&id=41c532e6&scoped=true"
import script from "./AgeLimits.vue?vue&type=script&lang=js"
export * from "./AgeLimits.vue?vue&type=script&lang=js"
import style0 from "./AgeLimits.vue?vue&type=style&index=0&id=41c532e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41c532e6",
  null
  
)

export default component.exports